const StyledCheckbox = styled.div`
  margin: 4px 14px 0 0;
`

const Checkbox = ({ name, label, isChecked }) => {
  return (
    <StyledCheckbox className="form-group">
      <label htmlFor={ name } className="control-label">
        <input type="checkbox" id={name} name={ name } value="1" defaultChecked={ isChecked } />&nbsp;
        { label }
      </label>
    </StyledCheckbox>
  )
}

Checkbox.propTypes = {
  name:       PropTypes.string.isRequired,
  label:      PropTypes.string.isRequired,
  isChecked:  PropTypes.bool.isRequired
}

export default Checkbox



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/shared/components/Checkbox.js